export default {
  app: true,
  clubsite: true,
  store: true,
  memberships: false,
  rewards: false,
  ticketing: true,
  clubtv: true,
  clickcollect: false,
  auctionsite: false
}
